import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { DataTablesModule } from 'angular-datatables';
import { HighchartsChartModule } from 'highcharts-angular';
import { BaseChartDirective } from 'ng2-charts';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../../../../shared/shared.module';
import { EnitComplainceRoutingModule } from '../../eComplaince-routing.module';
import { CtclModule } from '../../EnitTrade/ctcl/ctcl.module';
import { TradeAdminRoutingModule } from '../../tradeAdmin-routing.module';
import { AuditorRegistrationReportComponent } from '../CyberAudit/auditor-registration-report-component/auditor-registration-report-component';
import { AddCyberAuditUsersComponent } from './add-cyber-audit-users/add-cyber-audit-users.component';
import { } from './auditor-registration-report-component/auditor-registration-report-component';
import { BeforecyberdtlsComponent } from './beforecyberdtls/beforecyberdtls.component';
import { CellAtrCyberRendererComponent } from './cell-atr-cyber-renderer/cell-atr-cyber-renderer.component';
import { CellAtrRendererComponent } from './cell-atr-renderer/cell-atr-renderer.component';
import { CellCyberRendererComponent } from './cell-cyber-renderer/cell-cyber-renderer.component';
import { CyberAdminMISReportComponent } from './cyber-admin-misreport/cyber-admin-misreport.component';
import { CyberAdminSetupComponent } from './cyber-admin-setup/cyber-admin-setup.component';
import { CyberAuditApproveRejectComponent } from './cyber-audit-approve-reject/cyber-audit-approve-reject.component';
import { CyberAuditATRReportComponent } from './cyber-audit-atrreport/cyber-audit-atrreport.component';
import { CyberAuditEligibleUsersComponent } from './cyber-audit-eligible-users/cyber-audit-eligible-users.component';
import { CyberAuditFollowOnExchangeActionComponent } from './cyber-audit-follow-on-exchange-action/cyber-audit-follow-on-exchange-action.component';
import { CyberAuditFollowOnSubmissionComponent } from './cyber-audit-follow-on-submission/cyber-audit-follow-on-submission.component';
import { CyberAuditHeaderEditComponent } from './cyber-audit-header-edit/cyber-audit-header-edit.component';
import { CyberAuditMISReportComponent } from './cyber-audit-misreport/cyber-audit-misreport.component';
import { CyberAuditTORBuildingComponentComponent } from './cyber-audit-torbuilding-component/cyber-audit-torbuilding-component.component';
import { CyberAuditTORPreviewComponent } from './cyber-audit-torpreview/cyber-audit-torpreview.component';
import { CyberAuditComponent } from './cyber-audit/cyber-audit.component';
import { CyberAuditorMISComponent } from './cyber-auditor-mis/cyber-auditor-mis.component';
import { CyberAuditorRegistrationReportComponent } from './cyber-auditor-registration-report/cyber-auditor-registration-report.component';
import { CyberTorBuilderComponent } from './cyber-tor-builder/cyber-tor-builder.component';





@NgModule({
  declarations: [
    
    AddCyberAuditUsersComponent, AuditorRegistrationReportComponent,BeforecyberdtlsComponent,CellAtrCyberRendererComponent,
    CellAtrRendererComponent,CellCyberRendererComponent,
    CyberAdminMISReportComponent,CyberAdminSetupComponent,CyberAuditComponent,CyberAuditApproveRejectComponent,CyberAuditATRReportComponent,
    CyberAuditEligibleUsersComponent,CyberAuditFollowOnExchangeActionComponent,CyberAuditFollowOnSubmissionComponent,CyberAuditHeaderEditComponent,

CyberAuditMISReportComponent,CyberAuditTORBuildingComponentComponent,CyberAuditTORPreviewComponent,CyberAuditorMISComponent,
CyberAuditorRegistrationReportComponent,CyberTorBuilderComponent

  ],
  imports: [
    
    CommonModule,
    TradeAdminRoutingModule,
    FormsModule,
    DataTablesModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    BsDatepickerModule,
    SharedModule,
    CtclModule,
    EnitComplainceRoutingModule,
    AgGridModule,
    BaseChartDirective,
    HighchartsChartModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CyberAuditModule { }
